import { FilterObject } from './filter-object';
import * as lodash from 'lodash';

export class ContainsFilter extends FilterObject<any> {

  public filter(itemToFiltre: any): boolean {
    return this.doFilter(itemToFiltre, this.field, this.values);
  }

  public doFilter(itemToFiltre: any, field: any, value: any): boolean {
    if (value == null) {
      return true;
    }
    let result = false;
    if (field) {
      if (Array.isArray(itemToFiltre[field])) {
        result = result || this.doFilter(itemToFiltre[field], null, value);
      } else {
        if (itemToFiltre[field]) {
          let comp = itemToFiltre[field];

          comp = lodash.lowerCase(comp);
          comp = lodash.deburr(comp);

          value = lodash.lowerCase(value);
          value = lodash.deburr(value);

          result = result || (comp.indexOf(value) >= 0);
        }
      }
    } else {
      Object.keys(itemToFiltre).forEach(key => { //Parcours des propriétés de l'objet
        if (itemToFiltre[key] != null) {
          if (Array.isArray(itemToFiltre[key])) { //Cas des lignes de mise à jour
            result = result || this.doFilter(itemToFiltre[key], field, value)
          } else if (typeof itemToFiltre[key] == "string") {
            let comp = itemToFiltre[key];

            comp = comp.toLowerCase();
            comp = lodash.deburr(comp);

            value = value.toLowerCase();
            value = lodash.deburr(value);

            result = result || (comp.indexOf(value) >= 0);
          }
        }
      });
    }
    return result;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/contains.filter.ts